'use es6';

import { startsWith } from 'cookie-banner/utils/hspbUtils';
import { arrayContainsStr } from './hspbUtils';
export const CONFIG_TYPE_TO_MATCH_LEVEL = {
  DomainPathGeo: 6,
  DomainPath: 5,
  PathGeo: 4,
  Path: 3,
  DomainGeo: 2,
  Domain: 1,
  Geo: 0,
  noMatch: -1
};
export const getSettingsMatchLevel = (settings, policyTesting, context, visitorCountry) => {
  const isPolicyEnabled = settings.enabled || policyTesting;
  if (!isPolicyEnabled) {
    return CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
  }
  const settingsHasGeoTargeting = settings.targetedCountries && Array.isArray(settings.targetedCountries) && settings.targetedCountries.length > 0;
  const configType = `${settings.domain ? 'Domain' : ''}${settings.path ? 'Path' : ''}${settingsHasGeoTargeting ? 'Geo' : ''}`;
  if (configType === '') {
    return CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
  }
  const matchesDomain = settings.domain && context.getHostName() === settings.domain;
  const matchesPath = settings.path && startsWith(context.getPathName(), settings.path);
  const matchesGeo = settingsHasGeoTargeting && arrayContainsStr(settings.targetedCountries, visitorCountry);
  switch (configType) {
    case 'DomainPathGeo':
      return matchesDomain && matchesPath && matchesGeo ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    case 'DomainPath':
      return matchesDomain && matchesPath ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    case 'PathGeo':
      return matchesPath && matchesGeo ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    case 'Path':
      return matchesPath ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    case 'DomainGeo':
      return matchesDomain && matchesGeo ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    case 'Domain':
      return matchesDomain ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    case 'Geo':
      return matchesGeo ? CONFIG_TYPE_TO_MATCH_LEVEL[configType] : CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
    default:
      return CONFIG_TYPE_TO_MATCH_LEVEL.noMatch;
  }
};